import api from "../../../services/api";

export interface EcomEventByDate {
  id: number;
  title: string;
  description: string;
  source: string;
  channel:string;
  location: string;
  start_at: string;
  end_at: string;
}

export type EventsEcomMonthResponse = EcomEventByDate[];

export async function getEcomEventsMonthService(month: string): Promise<EventsEcomMonthResponse> {
  // month format: "2025-08" (YYYY-MM)
  const res = await api.get<EventsEcomMonthResponse>(`/api/key_points/ecommerce/by-month?month=${month}`);
  return res.data;
}